import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=92118358"
import script from "./ActivateAccount.vue?vue&type=script&lang=ts"
export * from "./ActivateAccount.vue?vue&type=script&lang=ts"
import style0 from "./ActivateAccount.vue?vue&type=style&index=0&id=92118358&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports